export const LOCATION_TYPE_LABELS = {
    1: 'Lager',
    2: 'Hofladen',
    3: 'Verkaufsautomat',
    4: 'Selbstbedienung'
};

export const getLocationTypeLabel = (value) => {
    const type = typeof value === 'string' ? parseInt(value, 10) : value;
    return LOCATION_TYPE_LABELS[type] || null;
};
